export function getMarketingPreferencesValues(values, consentForms, url) {
  const normalizeBooleanLikeValue = (value) => {
    if (value === 'true') return true;
    if (value === 'false') return false;
    return value;
  };

  const userConsentAnswers = [];

  consentForms.forEach(({ id, checkboxes }) => {
    const submitAnswerValue = values[id];

    userConsentAnswers.push({
      id,
      answers: checkboxes.map(({ name, checked: defaultAnswerValue }) => {
        return {
          channel: name,
          value: normalizeBooleanLikeValue(
            submitAnswerValue?.[name] ?? defaultAnswerValue,
          ),
        };
      }),
    });

    delete values[id];
  });

  return { defaultConsents: true, url, userConsentAnswers };
}
